import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const ContactInfoSection = ({ formData, errors, onChange, onAddEmail, onRemoveEmail, onAddPhone, onRemovePhone }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold text-foreground mb-4">
        Contatos
      </h2>
      {/* Email Addresses */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-3">
          <label className="text-sm font-medium text-foreground">
            E-mails
            <span className="text-error ml-1">*</span>
          </label>
          <Button
            variant="outline"
            size="sm"
            onClick={onAddEmail}
            iconName="Plus"
            iconPosition="left"
          >
            Adicionar e-mail
          </Button>
        </div>
        
        <div className="space-y-3">
          {formData?.emails?.map((email, index) => (
            <div key={index} className="flex items-end gap-2">
              <div className="flex-1">
                <Input
                  type="email"
                  placeholder={index === 0 ? "E-mail principal" : "E-mail adicional"}
                  value={email?.address}
                  onChange={(e) => onChange('emails', formData?.emails?.map((em, i) => 
                    i === index ? { ...em, address: e?.target?.value } : em
                  ))}
                  error={errors?.emails && errors?.emails?.[index]}
                  required={index === 0}
                />
              </div>
              <div className="w-32">
                <Input
                  type="text"
                  placeholder="Tipo"
                  value={email?.type}
                  onChange={(e) => onChange('emails', formData?.emails?.map((em, i) => 
                    i === index ? { ...em, type: e?.target?.value } : em
                  ))}
                />
              </div>
              {formData?.emails?.length > 1 && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onRemoveEmail(index)}
                  iconName="Minus"
                  className="text-error hover:text-error"
                />
              )}
            </div>
          ))}
        </div>
      </div>
      {/* Phone Numbers */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <label className="text-sm font-medium text-foreground">
            Telefones
            <span className="text-error ml-1">*</span>
          </label>
          <Button
            variant="outline"
            size="sm"
            onClick={onAddPhone}
            iconName="Plus"
            iconPosition="left"
          >
            Adicionar telefone
          </Button>
        </div>
        
        <div className="space-y-3">
          {formData?.phones?.map((phone, index) => (
            <div key={index} className="flex items-end gap-2">
              <div className="flex-1">
                <Input
                  type="tel"
                  placeholder={index === 0 ? "Telefone principal" : "Telefone adicional"}
                  value={phone?.number}
                  onChange={(e) => onChange('phones', formData?.phones?.map((ph, i) => 
                    i === index ? { ...ph, number: e?.target?.value } : ph
                  ))}
                  error={errors?.phones && errors?.phones?.[index]}
                  required={index === 0}
                />
              </div>
              <div className="w-32">
                <Input
                  type="text"
                  placeholder="Tipo"
                  value={phone?.type}
                  onChange={(e) => onChange('phones', formData?.phones?.map((ph, i) => 
                    i === index ? { ...ph, type: e?.target?.value } : ph
                  ))}
                />
              </div>
              {formData?.phones?.length > 1 && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onRemovePhone(index)}
                  iconName="Minus"
                  className="text-error hover:text-error"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactInfoSection;